export { VpHookFormFileDragAndDrop } from './VpHookFormFileDragAndDrop';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpHookFormFileDragAndDrop/index.js